import { Component } from '@angular/core';
import { Paginar } from 'src/app/models/http-paginacion.interface';
import { AuthService } from 'src/app/services/auth.service';
import { RedimirSupervisor } from 'src/app/models/redimir.interface';
import { Supervisor } from 'src/app/models/supervisor.interface';
import { DESCRIPCION_STATUS_CANJE } from 'src/app/shared/constantes/constants';
import { SupervisorService } from 'src/app/services/supervisor.service';

@Component({
    selector: 'app-supervisor-canjes',
    templateUrl: './supervisor-canjes.component.html',
    styleUrls: ['./supervisor-canjes.component.scss'],

})
export class SupervisorCanjesComponent {
    supervisor!: Supervisor;
    canjes!: RedimirSupervisor[];
    estatus: string[] = [...DESCRIPCION_STATUS_CANJE];
    currentPage: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
    totalItems: number = 10;

    constructor(private supervisorService: SupervisorService, private authService: AuthService) {

        if (this.authService.isLoggedIn) {
            const idSupervisor: number | undefined = this.authService.getUsuario?.supervisor?.id;
            if (idSupervisor) this.obtenerInformacion(idSupervisor);
        }

    }
    get totalPaginas(): number {
        return Math.ceil(this.canjes.length / this.currentPage.rows);
    }
    get paginacionCanjesSupervisores(): RedimirSupervisor[] {
        const startIndex = (this.currentPage.page) * this.currentPage.rows;
        return this.canjes.slice(startIndex, startIndex + this.currentPage.rows);
    }
    obtenerInformacion(id: number): void {
        this.supervisorService.getSupervisor(id).subscribe({
            next: (resp) => {
                this.supervisor = resp.datos;
                this.canjes = resp.datos.canjes;

                this.totalItems = resp.datos.canjes.length;

                //  console.log(resp)
            },
            error: (err) => console.log(err)
        });
    }
    getDescripcion(id: number): string {
        return this.estatus[id];
    }
    onPageChange(event: any) {
        this.currentPage = <Paginar>event;
    }


}